import FJObjectEraseRight from '../view/FJObjectEraseRight';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionObjectErase from '../../../../redux/action/FJActionObjectErase';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import { useCallback } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJObjectEraseRightContainer = memo(function FJObjectEraseRightContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const downloadEditImageLoading = useSelector(state => state.common.downloadEditImageLoading);
    const isNotImage = useSelector(state => state.objectErase.inputImageInfo === null);
    const hasEditImage = useSelector(state => {
        const editImage = state.brushEditCommon.editImage;
        return editImage && editImage.src && editImage.src !== ''
    });
    const isCanDownload = useSelector(state => {
        const { editImage, originImage } = state.brushEditCommon;
        return originImage && editImage && originImage.src !== editImage.src;
    });

    const _setIsDraggingFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch],
    );

    const uploadImg = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadImageAction(file));
        },
        [dispatch],
    );

    const download = useCallback(() => {
        dispatch(FJActionObjectErase.downloadEditImageAction());
    }, [dispatch]);

    return (
        <FJObjectEraseRight
            setIsDraggingFile={_setIsDraggingFile}
            uploadImg={uploadImg}
            headerTabIndex={headerTabIndex}
            taskStatus={taskStatus}
            isNotImage={isNotImage}
            downloadEditImageLoading={downloadEditImageLoading}
            download={download}
            isCanDownload={isCanDownload}
            hasEditImage={hasEditImage}
        />
    );
});

export default FJObjectEraseRightContainer;
